(function () {
  'use strict';

  /* global _ */
  class CadastroCtrl {

    constructor(AlertMessage, $location, $stateParams, moment, Compartilhamentos, Uos, $timeout, $translate, $scope,
                DiasDaSemana, TipoEntidades, Entidades, UoArvoreNivel, $q, $uibModal, ModalInfoConfirmService, EntidadeMap, VehiclesMap) {
      this.alertMessage = AlertMessage;
      this.location = $location;
      this.stateParams = $stateParams;
      this.moment = moment;
      this.modalService = $uibModal;
      this.$scope = $scope;
      this.compartilhamentoService = Compartilhamentos;
      this.uoService = Uos;
      this.timeout = $timeout;
      this.$translate = $translate;
      this.entidadeMap = EntidadeMap;
      this.vehiclesMap = VehiclesMap;
      this.diasDaSemanaService = DiasDaSemana;
      this.tipoEntidadeService = TipoEntidades;
      this.entidadeService = Entidades;
      this.uoArvoreNivel = UoArvoreNivel;
      this.modalInfoConfirmService = ModalInfoConfirmService;
      this.q = $q;
      this.isEdicao = false;
      this.compartilhamento = {};
      this.uos = null;
      this.uosCompartilhamento = [];
      this.tipoEntidades = null;
      this.entidades = null;
      this.diasDaSemana = null;
      this.todasAsEntidades = true;
      this.todasFilhas = false;
      this.periodoIndeterminado = true;
      this.todosOsDiasDaSemana = true;
      this.horarioIndeterminado = true;
      this.listFail = [];
      this.limit = 10;
      this.periodo = {
        startDate: this.moment({hour: 0, minute: 0}),
        endDate: this.moment({hour: 23, minute: 59})
      };
      this.enumEntidade = {
        TODOS: -1,
        USUARIOS: 6,
        PONTOS_DE_REFERENCIA: 7
      };
      this.horas = Array.apply(null, new Array(24)).map((_, i) => i);
      this.limitOrigem = 10;
      this.limitDestino = 10;
      this.ENTIDADES_PERMITIDAS_TODAS_FILHAS = [
        'PONTOS_DE_REFERENCIA', 'MOTORISTAS', 'GRUPOS_VEICULO', 'DEPARTAMENTOS_MOTORISTA', 'CERCAS_ELETRONICAS'
      ];
      this.init();

      this.$scope.translateTipoEntidade = (nomeEntidade) =>{
        if (EntidadeMap[nomeEntidade]) {
          const translatedPath = $translate.instant(`core-permissoes.organizacao.compartilhamentos.shareButton.${EntidadeMap[nomeEntidade]}`);
          return translatedPath;
        }

        return nomeEntidade;
      };
    }

    loadMoreOrigem() {
      this.limitOrigem += 10;
    }

    loadMoreDestino() {
      this.limitDestino += 10;
    }

    tipoPermiteEdicao() {
      return this.compartilhamento.tipoEntidade && this.compartilhamento.tipoEntidade.enumEntidade !== 'SERVICOS';
    }

    init() {
      this.carregarUos();
      this.carregarTipoEntidades();
      this.carregarDiasDaSemana();

      if (this.stateParams.id > 0) {
        this.isEdicao = true;
        this.compartilhamentoService.one(this.stateParams.id).get().then(data => {
          this.compartilhamento = data;
          this.periodoIndeterminado = data.periodoIndeterminado;
          this.todosOsDiasDaSemana = data.todosOsDiasDaSemana;
          this.horarioIndeterminado = data.horarioIndeterminado;
          if (!data.periodoIndeterminado) {
            this.periodo.startDate = this.moment(data.periodoInicio);
            this.periodo.endDate = this.moment(data.periodoFim);
          }
          if (angular.isUndefined(this.compartilhamento.uoCompartilhada)) {
            this.compartilhamento.uoCompartilhada = {id: -1, nome: 'TODAS AS FILHAS'};
          }
          if (angular.isUndefined(this.compartilhamento.tipoEntidade)) {
            this.compartilhamento.tipoEntidade = {id: -1, nome: 'TODAS AS ENTIDADES', enumEntidade: 'TODAS_ENTIDADES', todas: true};
          }
          if (angular.isDefined(data.entidades) && data.entidades.length > 0) {
            this.todasAsEntidades = false;
            this.carregarEntidades();
          }
          this.carregarUoCompartilhamento();
        });
      }
    }

    carregarUos() {
      this.uoService.getFilhas().then(data => {
        this.uos = this.uoArvoreNivel.converterEmLista(data.plain());
      });
    }

    carregarUoCompartilhamento() {
      this.uosCompartilhamento = [{id: -1, nome: this.$translate.instant('core-permissoes.organizacao.compartilhamentos.allChildUos')}];
      if (this.compartilhamento.uo !== null) {
        this.carregarUosParceiras();
        this.carregarUosFilhas();
        this.carregarUosIrmas();
      }
    }

    carregarUosParceiras() {
      this.uoService.getParceiras(this.compartilhamento.uo.id).then(data => {
        let parceiras = _.map(data.plain(), element => {
          return _.extend({}, element, {tipo: this.$translate.instant('core-permissoes.organizacao.compartilhamentos.partnersUos')});
        });
        this.uosCompartilhamento = this.uosCompartilhamento.concat(parceiras);
      });
    }

    carregarUosIrmas() {
      this.uoService.getIrmas(this.compartilhamento.uo.id).then(data => {
        let irmas = _.map(data.plain(), element => {
          return _.extend({}, element, {tipo: this.$translate.instant('core-permissoes.organizacao.compartilhamentos.siblingUos')});
        });
        this.uosCompartilhamento = this.uosCompartilhamento.concat(irmas);
      });
    }

    carregarUosFilhas() {
      this.uoService.getFilhas(this.compartilhamento.uo.id).then(data => {
        let filhas = this.uoArvoreNivel.converterEmLista(data.plain());
        filhas = _.map(filhas, element => {
          return _.extend({}, element, {tipo: this.$translate.instant('core-permissoes.organizacao.compartilhamentos.childUos')});
        }).filter(u => u.id !== this.compartilhamento.uo.id);
        this.uosCompartilhamento = this.uosCompartilhamento.concat(filhas);
      });
    }

    carregarTipoEntidades() {
      this.tipoEntidadeService.getList().then(data => {
        if (this.todasFilhas) {
          this.tipoEntidades = data.plain()
            .filter(e => this.ENTIDADES_PERMITIDAS_TODAS_FILHAS.includes(e.enumEntidade));
          this.compartilhamento.tipoEntidade = this.tipoEntidades[0];
        } else {
          let todas = {
            id: -1,
            nome: 'TODAS AS ENTIDADES',
            enumEntidade: 'TODAS_ENTIDADES',
            todas: true};
          this.tipoEntidades = data.plain();
          this.tipoEntidades.push(todas);
          this.compartilhamento.tipoEntidade = todas;
        }
      });
    }

    carregarDiasDaSemana() {
      this.diasDaSemanaService.getList().then(data => {
        this.diasDaSemana = data.plain();
      });
    }

    carregarEntidades() {
      const enumEntidade = this.compartilhamento.tipoEntidade.enumEntidade,
          uoId = this.compartilhamento.uo.id;

      if (enumEntidade !== null && uoId !== null && this.todasAsEntidades === false) {
        if (!this.compartilhamento.entidades) {
          this.compartilhamento.entidades = [];
        }
        this.entidadeService.getEntidades(enumEntidade, uoId).then(data => {
          this.entidades = data.plain();
          this.compartilhamento.entidades = this.entidades
            .filter(entidade => this.compartilhamento.entidades.indexOf(entidade.id) !== -1);
        });
      } else {
        this.entidades = null;
        this.listFail = [];
        this.compartilhamento.entidades = null;
      }
    }

    limparDiasDaSemana() {
      this.compartilhamento.diasDaSemana = null;
    }

    limparHorario() {
      this.compartilhamento.horaInicio = null;
      this.compartilhamento.horaFim = null;
    }

    salvar() {
      this.setPeriodo();

      if (this.compartilhamento.tipoEntidade.id === -1) {
        this.compartilhamento.tipoEntidade = null;
      }
      if (this.compartilhamento.uoCompartilhada.id === -1) {
        this.compartilhamento.uoCompartilhada = null;
      }

      let compartilhamento = angular.copy(this.compartilhamento);

      if (compartilhamento.entidades && compartilhamento.entidades.length > 0) {
        compartilhamento.entidades = compartilhamento.entidades.map(item => item.id);
      }

      this.compartilhamentoService.post(compartilhamento)
      .then(() => {
        this.location.url('/compartilhamentos?saveSuccess=true');
      })
      .catch((responseError) => {
        let msg;
        if (responseError.status === 409) {
          msg = 'Já existe um compartilhamento desse tipo entre as mesmas UOs.';
        }
        this.alertMessage.create({
          type: 'error',
          message: 'Erro. ' + (msg || responseError.data.erro),
          appendTo: '.alerta-aqui'});
      });
    }

    setPeriodo() {
      if (this.periodoIndeterminado) {
        this.compartilhamento.periodoInicio = null;
        this.compartilhamento.periodoFim = null;
      } else {
        this.compartilhamento.periodoInicio = this.periodo.startDate.toDate();
        this.compartilhamento.periodoFim = this.periodo.endDate.toDate();
      }
    }

    excluir() {
      this.modalService.open({
        templateUrl: 'compartilhamentos/confirm-delete-modal/confirm-delete-modal.tpl.html',
        controller: 'ConfirmDeleteModalCtrl',
        controllerAs: 'ctrl',
        size: 'md',
        resolve: {
          compartilhamento: () => this.compartilhamento
        }
      }).result
      .then(() => {
        this.compartilhamento.remove()
        .then(() => {
          this.location.url('/compartilhamentos?deleteSuccess=true');
        }).catch((data) => {
          this.modalInfoConfirmService.confirmModal({
            title: 'Compartilhamento em uso',
            conteudo: data.data.message && data.data.status === 400 ? data.data.message : 'Algo de errado aconteceu.',
            btnPrimario: 'OK'
          });
        });
      });
    }

    limparVariaveisControle() {
      this.todasAsEntidades = true;
      this.compartilhamento.entidades = null;
      this.listFail = [];
      this.listSuccess = [];
    }

    setItens(e) {
      this.timeout(() => {
        const valueInput = angular.copy(e.search);
        _.uniq(this.buildItens(valueInput))
        .forEach(item => {
          e.select(item);
        });
        e.search = '';
      }, 100);
    }

    buildItens(valueInput) {
      const regex = /(,|;)/;
      return valueInput
      .split(regex)
      .filter(e => !regex.exec(e))
      .filter(e => !!e)
      .map((i) => {
        const item = this.buildSearch(i),
            search = this.entidades.find(x => this.buildSearch(x.descricao).includes(item)),
            repetido = !this.compartilhamento.entidades.some(x => this.buildSearch(x.descricao).includes(item));
        if (search && repetido) {
          return search;
        }
        if (!this.listFail.some(x => this.buildSearch(x).includes(item)) && repetido) {
          this.listFail.push(i);
        }
        return null;
      })
      .filter(e => !!e);
    }

    buildSearch(item) {
      return item.replace(/(\s|-)/g, '').toLowerCase();
    }

    removeInvalidItem(index) {
      this.listFail = this.listFail.filter((item, i) => i !== index);
    }

    exibirEntidades() {
      return this.compartilhamento.tipoEntidade &&
      this.compartilhamento.tipoEntidade.id !== this.enumEntidade.TODOS &&
      this.compartilhamento.tipoEntidade.id !== this.enumEntidade.USUARIOS &&
      this.compartilhamento.tipoEntidade.id !== this.enumEntidade.PONTOS_DE_REFERENCIA;
    }

    loadMore() {
      this.limit += 10;
    }
  }

  /**
   * @ngdoc object
   * @name compartilhamentos.controller:CadastroCtrl
   *
   * @description
   *
   */
  angular
    .module('compartilhamentos')
    .factory('DiasDaSemana', Restangular => {
      return Restangular.service('auth/diasDaSemana');
    })
    .factory('TipoEntidades', Restangular => {
      return Restangular.service('auth/tipo-entidades');
    })
    .controller('CadastroCtrl', CadastroCtrl);
}());
